import gtag, { gtag4Event, GtagConfig } from '../gtag';
import { trackEventFacebook } from './facebook';
import { TrackPurchaseEventParams } from './types';

export function trackCheckout(tripId: number, eventCategory: 'checkout' | 'instabook checkout'): void {
  gtag('event', 'Click to checkout', {
    event_category: eventCategory,
  });
  trackEventFacebook('InitiateCheckout', { content_ids: [tripId] });
}

export function trackRegistration() {
  gtag('event', 'New Registration', {
    event_category: 'Authentication',
  });
  trackEventFacebook('CompleteRegistration');
}

/**
 * Sends an event to multiple analytics platforms (currently GA4)
 * @param eventName event type
 * @param config event parameters (custom params)
 */
export function trackEvent(
  eventName: string,
  config: GtagConfig = {},
): void {
  // Send to GA4
  gtag4Event(eventName, config);
}

/**
 * Send the purchase event via Gtag GTM and onwards to Google Analytics
 * @param params Booking transaction details and locale
 */
export function trackPurchaseEvent({
  transactionId,
  bookingTotal,
  currency,
  locale,
  boatId,
  boatHeadline,
  initialLandingPage,
  isInstabook,
  isDirectBooking,
  freeCancellation,
}: TrackPurchaseEventParams) {
  let purchaseType = isInstabook ? 'marketplace_instabook' : 'marketplace';
  if (isInstabook && isDirectBooking) { purchaseType = 'book-now-direct'; }

  trackEvent('purchase', {
    transaction_id: transactionId,
    affiliation: 'GMB Booking',
    event_category: 'checkout',
    value: bookingTotal,
    currency,
    tax: 0,
    tax_rate: 0,
    shipping: 0,
    purchase_type: purchaseType,
    locale,
    items: [{
      id: boatId,
      item_id: boatId,
      item_name: boatHeadline,
      quantity: 1,
      price: bookingTotal,
    }],
    p1: initialLandingPage?.url,
    p2: initialLandingPage?.referrer,
    p3: initialLandingPage?.gclid,
    p4: initialLandingPage?.utmValues?.utm_source,
    p5: initialLandingPage?.utmValues?.utm_medium,
    p6: initialLandingPage?.utmValues?.utm_campaign,
    p7: initialLandingPage?.utmValues?.utm_term,
    p8: initialLandingPage?.utmValues?.utm_content,
    p9: freeCancellation,
  });
}
